type AdConsentModalProps = {
  labels: {
    title: string;
    body: string;
    allow: string;
    keepNonPersonalized: string;
  };
  onAllow: () => void;
  onKeepNonPersonalized: () => void;
};

export function AdConsentModal({ labels, onAllow, onKeepNonPersonalized }: AdConsentModalProps) {
  return (
    <div className="sheet-overlay" onClick={() => undefined}>
      <div className="sheet onboarding-sheet legal-consent-sheet" onClick={(e) => e.stopPropagation()}>
        <div className="sheet-header">
          <h3>{labels.title}</h3>
        </div>
        <div className="small legal-consent-body">{labels.body}</div>
        <div className="timer-buttons onboarding-actions">
          <button onClick={onKeepNonPersonalized}>{labels.keepNonPersonalized}</button>
          <button onClick={onAllow}>{labels.allow}</button>
        </div>
      </div>
    </div>
  );
}
